import { useMemo } from 'react';
import { useShortFromPropsOrParams } from '../shortContentHooks';
import { LearningContentPageHeader } from '../../learningContent/components/LearningContentPageHeader';
import { SocialShareDropdown } from '../../share';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { CardMenuIcon } from '../../cardMenu';
import { DesktopRatingsContainer, useGetPreviousReview } from '../../ratingsAndReview';
import { useUserInfo } from '../../accounts';
import { useCurrentVideoTime } from '../../video/components/VideoPlayerWithControls';
import { AcademyRatingsTypes } from '../../../constants/RatingsAndReviewConstants';
import { useIsHubspotPlaylist, usePlaylist } from '../../savedItems';
import { View } from 'foundations-components/transitional/components/View';

/**
 * The number of seconds to wait before showing the ratings container
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RATINGS_CONTAINER_PROGRESS_TIMEOUT = 10;
export const ShortContentHeader = props => {
  const {
    short,
    playlistId
  } = useShortFromPropsOrParams(props);
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const {
    currentVideoTime
  } = useCurrentVideoTime();
  const {
    userInfo
  } = useUserInfo();
  const {
    previousReview
  } = useGetPreviousReview({
    entityId: short === null || short === void 0 ? void 0 : short.contentId,
    reviewTypes: [AcademyRatingsTypes.ACADEMY_ON_THE_GO],
    reviewerUserId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.id
  });
  const {
    playlist
  } = usePlaylist(Number(playlistId), !playlistId);
  const isHubspotPlaylist = useIsHubspotPlaylist(playlist);
  const showRatings = useMemo(() => !isTablet && (previousReview || currentVideoTime > RATINGS_CONTAINER_PROGRESS_TIMEOUT), [previousReview, currentVideoTime, isTablet]);
  if (!short) return null;
  const {
    name,
    contentId: shortId
  } = short;
  const item = {
    id: shortId,
    type: 'SHORT_FORM_CONTENT'
  };
  const itemWithPlaylist = Object.assign({}, item, {
    playlistId
  });
  const instructorIds = short.professors.map(instructor => instructor.id);
  const ratingsAdditionalTrackingData = Object.assign({
    contentLanguage: short.language,
    contentName: short.name,
    creatorHubId: short.hubId,
    hsSoftwareFilters: short.hubSpotSoftwareTools,
    professorId: instructorIds,
    subCategory: short.subCategories,
    useCase: short.useCases,
    videoProgress: currentVideoTime,
    isHubspotPlaylist
  }, playlist && {
    playlistId,
    playlistName: playlist.name
  });
  return /*#__PURE__*/_jsx(LearningContentPageHeader, {
    item: itemWithPlaylist,
    title: name,
    children: isMobile ? /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(CardMenuIcon, {
        item: item,
        itemToShare: playlistId ? itemWithPlaylist : undefined,
        placement: "bottom left"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [showRatings && /*#__PURE__*/_jsx(DesktopRatingsContainer, {
        additionalTrackingData: ratingsAdditionalTrackingData,
        contentId: shortId,
        reviewType: AcademyRatingsTypes.ACADEMY_ON_THE_GO
      }), /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(CardMenuIcon, {
          item: item,
          placement: "bottom left"
        })
      }), /*#__PURE__*/_jsx(SocialShareDropdown, {
        item: itemWithPlaylist
      })]
    })
  });
};
export default ShortContentHeader;